var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBf = function SvgBf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de0000",
    d: "M640.003 479.578H.378V0h639.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35a100",
    d: "M639.628 480H.003V240.216h639.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff300",
    d: "M254.612 276.188l-106.066-72.434 131.043.122 40.386-117.322 40.388 117.322 131.043-.087-106.085 72.398 40.59 117.27-105.954-72.573-105.955 72.556"
  }))));
};
export default __webpack_public_path__ + "assets/564329b06b9b0f83f9a677f0a696d684.svg";
export { SvgBf as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/bf.svg